import { styled } from '@mui/material/styles';
import { Toolbar } from 'react-admin';

export const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  minHeight: '0 !important',
  marginBottom: '24px',
}));
